const manageuser = {
    currentsite: "Núverandi reikningur",
    whohasaccess: "Hver hefur aðgang",
    thisisyourprivateaccount:"Þetta er þinn persónulegi reikningur",
    youllneedto:"Þú þarft að stofna, skipta yfir í, eða láta bjóða þér aðgang að fullum reikningum til að fá geta möndlað með viðburði, fá auglýsingabirtingar skrifaðar ofl.",
    createsite: "Stofna fullan reikning",
    youraccounts: "Þínir reikningar",
    letsgetstarted: "Komum þessu af stað",
    startingout: "Til að komast af stað þarftu að stofna fullan reikning. Það er sá reikningur sem fær aðgang að viðburðum, getur bókað auglýsingar og fleira." +
                 " Þú getur haft aðgang að fleiri en einum fullum reikningi (til að sjá um marga tónlistarmenn, staði eða vefsíður) og þú getur auðveldlega skipt á milli þeirra." +
                 " Eins geta fleiri en einn haft aðgang að sama reikningnum.",


    welcome: "Welcome",
    logout: "Log out",
    upcoming: "Viðburðir framundan",
    admarket: "Auglýsingar",
    createevent: "Skrá viðburð",
    importevents: "Flytja inn viðburði",
    userdashboard: "Stillingar notanda",
    nameofaccount: "Nafn reiknings",
    nameofbusiness: "Nafn fyrirtækis",
    kennitala: "Kennitala",
    emailforinvoicing: "Netfang fyrir reikninga",
    podepartment: "PO / deild / verkefni",
    urltopost: "Vefslóð til að pósta reikningum (ef til)",
    electronicinvoicing: "Rafrænn reikningur",
    youcanhaveaccess: "Þú getur haft fleiri en einn reikning, sem kemur sér vel ef það þarf t.d. að aðgreina reikninga fyrir auglýsingar.",
    createbutton: "Stofna",
    createinfo: "Ef þú vilt kaupa auglýsingar í reikning þarftu að segja okkur hver á að borga. Þú getur líka stillt þetta seinna.",
    hello: "Halló",
    createuser: "Stofna notanda",
    createanaccount: "Stofnaðu þig sem notanda",
    createaccountinfo: "Svo geturðu stofnað eða tengst reikningum til að halda utan um viðburði eða auglýsingar.",
    yourname: "Nafn þitt",
    email: "Tölvupóstur",
    password: "Lykilorð",
    alreadyamember: "Þegar á skrá?",
    login: "Innskrá",
    showconnector: "Tengjast",
    showconnectorinfo: "Veldu listamann eða stað til að tengjast.",
    showconnectorinfodetail: "Það tengir gögnin og hjálpar til við að finna viðburði og möndla með auglýsingar.",
    setpaymentinfo: "Greiðsluupplýsingar",
    showpaymentinfo: "Greiðsluupplýsingar.",

    savebutton: "Vista",

    canedit: "Aðgangur til að stofna og breyta viðburðum",
    caneditinfo: "Eins og gefur að skilja getum við ekki hleypt hverjum sem er í það. Við verðum því að tryggja að þú megir gera það.",
    canedityes: "Þú hefur aðgang",
    caneditno: "Þú hefur ekki aðgang",
    howtorequestaccess: "Hvernig á að óska eftir aðgangi? Segðu okkur af hverju þú þarft aðgang að þessum reikningi og við munum skoða það.",
    wantstoeditevents: "þarf aðgang til að breyta viðburðum",
    reasonforaccess: "Ástæða fyrir aðgangi",
    requestaccess: "Óska eftir aðgangi",
    showeditrequest: "Biðja um aðgang",
    commentplaceholder: "Ástæðan fyrir því af hverju þú vilt aðgang",
    imagecollection: "Myndasafn",



};
export default manageuser;
